import { useSelector } from 'react-redux';
import { getBackendBoolean } from '@Sage/ssm-utils/backendScalars';

export const useShippingAddressPermissions = () => {
    const permission = useSelector((state) => state.config?.permission);
    return {
        canAdd: getBackendBoolean(permission?.addShippingAddressToAccounts),
        canEdit: getBackendBoolean(permission?.editShippingAddressToAccounts),
    };
};
